module.exports = __webpack_public_path__ + "static/isobar-logo-orange-d735435edca6f69e34b6c6319cecd47d.png";